import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { createSelector } from "reselect";
import { AppState } from "../store/definitions";

const useIsTaskAcceptedSelector = createSelector(
    (state: AppState) => state,
    (state) => ({
        participants: state.chat.participants,
        isEscalated: state.bot.isEscalated
    })
);

export const useIsTaskAccepted = () => {
    const { participants, isEscalated } = useSelector(useIsTaskAcceptedSelector);

    const [isTaskAccepted, setIsTaskAccepted] = useState<boolean>(false);

    useEffect(() => {
        if (isEscalated && participants && participants?.length > 1) {
            setIsTaskAccepted(true);
        } else {
            setIsTaskAccepted(false);
        }
    }, [isEscalated, participants]);

    return { isTaskAccepted };
};